import { InjectionToken } from '@angular/core';

export const EVENTS_API_URL = new InjectionToken<string>('EVENTS_API_URL');
